import { upperFirst } from 'lodash';
import moment from 'moment';
import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { FaEdit } from 'react-icons/fa';

export const commaSeparatedAllopathyTypes = ['frequency', 'dose', 'duration', 'timing', 'severity'];

export const useAllopathyType = (t) => useMemo(() => {
	return [
		{ value: 'complaints', label: t('ALLOPATHY.NAV.COMPLAINTS') },
		{ value: 'diagnosis', label: t('ALLOPATHY.NAV.DIAGNOSIS') },
		{ value: 'test', label: t('ALLOPATHY.NAV.TEST') },
		{ value: 'advice', label: t('ALLOPATHY.NAV.ADVICE') },
		{ value: 'diet-exerise', label: t('ALLOPATHY.NAV.DIET_EXERISE') },
		{ value: 'frequency', label: t('ALLOPATHY.NAV.FREQUENCY') },
		{ value: 'dose', label: t('ALLOPATHY.NAV.DOSE') },
		{ value: 'duration', label: t('ALLOPATHY.NAV.DURATION') },
		{ value: 'timing', label: t('ALLOPATHY.NAV.TIMING') },
		{ value: 'severity', label: t('ALLOPATHY.NAV.SEVERITY') },
	];
}, [t]);

export const useAllopathyColumn = ({ t, currentPage, perPage, handleEdit, title, type }) => {
	return useMemo(() => [
		{
			name: '#',
			selector: (_, index) => (currentPage - 1) * perPage + index + 1,
			maxWidth: '55px',
			minWidth: '55px',
			center: true,
		},
		{
			name: t(`ALLOPATHY.TABLE.${['advice', 'diet-exerise'].includes(type) ? 'TITLE' : 'NAME'}`, { title }),
			selector: row => row.name,
			wrap: true,
			sortable: true,
			sortField: 'name',
		},
		...(['advice', 'diet-exerise'].includes(type) ? [
			{
				name: t('ALLOPATHY.TABLE.ADVICE'),
				selector: row => row.advice,
				grow: 2,
				wrap: true,
				sortable: true,
				sortField: 'advice',
			},
		] : []),
		...(commaSeparatedAllopathyTypes.includes(type) ? [] : [{
			name: t('MEDICIENS.TABLE.STATUS'),
			cell: row => (
				<span className={row.status === 'inactive' ? 'text-danger' : 'text-success'}>
					{upperFirst(row.status)}
				</span>
			),
			wrap: true,
			sortable: true,
			sortField: 'status',
		},]),
		{
			name: t('EXAMINATIONS.TABLE.DATE'),
			selector: row => moment(row.created_at).format('DD-MM-YYYY'),
			wrap: true,
			sortable: true,
			sortField: 'created_at',
		},
		{
			cell: (row) => (
				<Button variant="warning" size="sm" onClick={() => handleEdit(row.id)}>
					<FaEdit style={{ color: 'white' }} />
				</Button>
			),
			button: true,
			minWidth: '70px',
			grow: 0
		}
	], [t, currentPage, perPage, handleEdit, title, type]);
};
